import buildInstitutionURL from '$utils/buildInstitutionURL';

// eslint-disable-next-line import/prefer-default-export
export const buildSSAAssignmentURL = ({ assignmentId, space }) =>
  buildInstitutionURL({
    subdomain: 'success',
    path: `${space}/assignment/${assignmentId}`,
  });
